import { render, staticRenderFns } from "./IdeasoftOrderStatus.vue?vue&type=template&id=72bc71e4"
import script from "./IdeasoftOrderStatus.vue?vue&type=script&lang=js"
export * from "./IdeasoftOrderStatus.vue?vue&type=script&lang=js"
import style0 from "./IdeasoftOrderStatus.vue?vue&type=style&index=0&id=72bc71e4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports